import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractView(sale: Element): string | undefined {
  return extractAdjustmentDescription(sale, 'View');
}
